<template>
  <div id="details">
    <div class="container">
      <router-link to="/" id="link">
        <button class="btn back color-change"><i class="fas fa-long-arrow-alt-left"></i>Back</button>
      </router-link>
      <div class="country-wrapper">
        <div class="flag">
          <img :src="countryData.flag" alt="flag">
        </div>
        <div class="info-wrapper">
          <h2 class="country-name color-change">{{ countryData.name }}</h2>
          <div class="country-info">
            <div class="block1">
              <p class="native-name color-change">
                <span class="bold">Native Name:</span> {{ countryData.nativeName }}
              </p>
              <p class="population color-change">
                <span class="bold">Population:</span> {{ countryData.population }}
              </p>
              <p class="region color-change">
                <span class="bold">Region:</span> {{ countryData.region }}
              </p>
              <p class="sub-region color-change">
                <span class="bold">Sub Region:</span> {{ countryData.subregion }}
              </p>
              <p class="capital color-change">
                <span class="bold">Capital:</span> {{ countryData.capital }}
              </p>
            </div>
            <div class="block2">
              <p class="tld color-change">
                <span class="bold">Top Level Domain:</span> {{ countryData.topLevelDomain[0] }}
              </p>
              <p class="currencies color-change">
                <span class="bold">Currencies:</span> {{ countryData.currencies[0].name }}
              </p>
              <p class="languages color-change">
                <span class="bold">Languages:</span> {{ countryData.languages[0].name }}
              </p>
            </div>
          </div>
          <div class="border-countries">
            <p class="text color-change"><span class="bold">Border Countries:</span></p>
            <div class="borders">
              <button class="btn border-btn color-change" v-for="border in countryData.borders">{{ border }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      country: this.$route.params.country,
      countryData: {}
    }
  },
  created() {
    fetch('https://restcountries.eu/rest/v2/name/'+this.country).then(res => res.json()).then(data => {
      this.countryData = data[0];
    });
  }
}
</script>

<style scoped>

a {
  text-decoration: none;
}

#details {
    padding: 7rem 0;
}

.container {
  width: 90%;
  margin: 0 auto;
}

.back {
  box-shadow: 0 0 .5rem rgba(0,0,0,.5);
  padding: .6rem 2rem;
  transition: .4s ease;
}

.back .fas {
  margin-right: 1rem;
  font-size: 1.2rem;
}

.country-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 7rem;
  width: 100%;
}

.flag {
  margin-bottom: 5rem;
  width: 100%;
  height: 30rem;
}

.flag img {
  width: 100%;
  height: 100%;
}

.country-info {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.country-name {
  font-size: 2rem;
  margin-bottom: 2rem;
}

.block1 {
  margin-bottom: 4rem;
}

.country-info p {
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.bold {
  font-weight: 800;
}

.block2 {
  margin-bottom: 3rem;
}

.border-countries {
  display: flex;
  flex-direction: column;
}

.border-countries .text {
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
}

.border-btn {
  margin-right: 1.5rem;
  padding: .5rem 1.8rem;
  font-size: .6rem;
  box-shadow: 0 0 .5rem rgba(0,0,0,.3);
  transition: .4s ease;
}

/* MEDIA QUERIES */
@media (min-width: 550px) {
  .country-info {
    flex-direction: row;
  }

  .block1 {
    margin-right: 6rem;
  }

  .border-countries {
    flex-direction: row;
  }

  .border-countries .text {
    margin-bottom: 0;
    margin-right: 2rem;
  }
}

@media (min-width: 860px) {
  #details {
    height: 90vh;
    padding-bottom: 0;
  }

  .country-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
  }
}

@media (min-width: 1300px) {
  .flag {
    width: 80%;
  }

  .block1 {
    margin-right: 9rem;
  }

  .country-name {
    font-size: 3.2rem;
  }

  .bold {
    font-size: 1.4rem;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/country.vue